import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const FacebookColors = createInteractiveColorVars('facebook');
const FacebookColorsLightValues = Object.freeze({
    base: {
        default: '#0766ff',
        action: '#0050d1',
        active: '#0766ff',
        activeAction: '#0050d1',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const FacebookColorsDarkValues = Object.freeze({
    base: {
        default: '#0766ff',
        action: '#0050d1',
        active: '#0766ff',
        activeAction: '#0050d1',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { FacebookColors, FacebookColorsDarkValues, FacebookColorsLightValues };
